import React, { useEffect, useState } from 'react'
import { Typography, Grid, Card, CardHeader } from '@mui/material';
import { LineChart, mangoFusionPalette } from '@mui/x-charts';
import axios from 'axios';

/**
 * TimeProfileLineChartCard displays a line chart showing the time profile of task categories over the day.
 * Each line represents a different task category, and the chart shows the average hours per day
 * spent on each category at each hour of the day (0-23), averaged over the past month.
 */
export default function TimeProfileLineChartCard() {
  const [dataset, setDataset] = useState([])
  const [series, setSeries] = useState([])
  
  const refreshData = () => {
    // Get user's timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    axios.get('/api/public/kron/stats/time_profile', { params: { timezone: userTimezone } }).then(({data : {dataset, series}}) => {
      setDataset(dataset)
      setSeries(series)
    })
  }
  
  useEffect(() => {
    refreshData()
  }, [])
  
  return (
    <Grid size={{ xs: 12, lg: 6 }}>
      <Card sx={{ px: 2, py: 1 }} variant='outlined'>
        <CardHeader
          title={
            <Typography variant="body2" component="h6" gutterBottom>
              Time profile over the day
            </Typography>
          }
          sx={{ p: 1 }}
        />
        <LineChart
          dataset={dataset}
          xAxis={[{
            scaleType: 'linear',
            dataKey: 'hour',
            min: 0,
            max: 23,
            tickInterval: [0, 3, 6, 9, 12, 15, 18, 21],
            valueFormatter: value => {
              const hour = Math.floor(value)
              const period = hour >= 12 ? 'pm' : 'am'
              const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour
              return `${displayHour}${period}`
            },
          }]}
          series={
            series.map(s => ({
              dataKey: s,
              label: s,
              showMark: false,
              curve: 'monotoneX',
            }))
          }
          colors={mangoFusionPalette}
          margin={{ top: 12, right: 12, bottom: 48, left: 48 }}
          yAxis={[{ 
            label: 'Avg hours/day',
            min: 0,
          }]}
          height={300}
          slotProps={{
            legend: {
              labelStyle: {
                fontSize: 12,
              },

              itemMarkHeight: 12,
              itemMarkWidth: 12,
              padding: 0,

              position: {
                vertical: 'bottom',
                horizontal: "center"
              }
            }
          }} />
      </Card>
    </Grid>
  );
}
